import { ActionIcon, Box, Card, Center, Group, Loader, Stack, Text, useMantineTheme } from "@mantine/core";
import { IconAlertTriangle, IconCheck, IconFile, IconTrash } from "@tabler/icons-react";
import { match } from "ts-pattern";

interface FileUploadCardProps {
  file?: File;
  status?: "loading" | "success" | "error";
  onDelete: () => void;
}

const FileUploadCard: React.FC<FileUploadCardProps> = ({ file, status, onDelete }) => {
  const theme = useMantineTheme();

  const changeFromBytesToKB = (bytes: number) => Math.round((bytes / 1024) * 10) / 10;

  const statusComponents = match(status)
    .with("loading", () => ({ color: "dimmed", text: "アップロード中...", icon: <Loader size="sm" /> }))
    .with("success", () => ({ color: "green", text: "アップロード完了", icon: <IconCheck color="green" /> }))
    .with("error", () => ({ color: "red", text: "アップロード失敗", icon: <IconAlertTriangle color="red" /> }))
    .with(undefined, () => ({ color: "", text: "", icon: <></> }))
    .exhaustive();

  if (!file) {
    return (
      <Card withBorder radius="md" padding="md" bg="var(--mantine-color-body)">
        <Box
          style={{
            height: "55.59px",
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
          }}
        >
          選択されているファイルがありません。
        </Box>
      </Card>
    );
  }

  return (
    <Card
      withBorder
      radius="md"
      padding="md"
      bg="var(--mantine-color-body)"
      style={{ flexDirection: "row" }}
      data-testid="file-upload-card"
    >
      <Card.Section style={{ marginBottom: "calc(var(--card-padding)* -1)" }}>
        <Box h={90} bg={theme.colors.gray[1]}>
          <Center h="100%" w="140px">
            <IconFile size={28} color={theme.colors.gray[8]} />
          </Center>
        </Box>
      </Card.Section>

      <Group pl={30} w="100%" justify="space-between">
        <Stack gap="xs">
          <Text size="lg" fw={500}>
            {file.name}
          </Text>
          <Text size="xs" tt="uppercase" fw={700} c="dimmed">
            {changeFromBytesToKB(file.size)} KB
          </Text>
        </Stack>
        <Group>
          {status && (
            <Group>
              <Text size="sm" c={statusComponents.color}>{statusComponents.text}</Text>
              {statusComponents.icon}
            </Group>
          )}
          <ActionIcon
            onClick={onDelete}
            variant="light"
            color="black"
          >
            <IconTrash style={{ width: "70%", height: "70%" }} stroke={1.5} />
          </ActionIcon>
        </Group>
      </Group>
    </Card>
  );
};

export default FileUploadCard;
